export default __webpack_public_path__ + "static/media/44.f03adf2c.png";